import { Wrench } from 'lucide-react'
import { PlateChromeProvider, usePlateChrome } from '../store/plateChrome'
import { GlobalButtonsBar } from './PlateLayout'
import { AppLayout } from './layout/AppLayout'
import { UserMenu } from './layout/UserMenu'

// Garage's dedicated workspace shell — TailAdmin's header (no sidebar: Garage has no nav of its
// own; its whole content area is whichever Plate is routed via PlateViewerPage, per the "nothing
// outside the plates rendering" requirement). The current Plate's headerTitle and global buttons
// arrive through PlateChromeProvider.
export function GarageDashboardLayout() {
  return (
    <PlateChromeProvider>
      <GarageDashboardLayoutInner />
    </PlateChromeProvider>
  )
}

function GarageDashboardLayoutInner() {
  const chrome = usePlateChrome()
  return (
    <AppLayout
      brand={{ name: chrome?.headerTitle ?? 'Garage', icon: Wrench }}
      homeTo="/garage"
      sections={null}
      mainClassName="w-full"
      headerRight={
        <>
          {chrome && <GlobalButtonsBar buttons={chrome.globalButtons} runInputs={chrome.runInputs} />}
          <UserMenu showProfile={false} />
        </>
      }
    />
  )
}
